import React from 'react';
import { Helmet } from 'react-helmet';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';

import PageHeaderSection from './pageHeaderSection';
import MountainInfoSection from './mountainInforSection';
import CombinedBarSection from './combinedBarSection';
import DiamondInfoSection from './diamondInfoSection';

import './main.css';
import mountainVideo from './images/whatfixvideo.webm';
import graphic from './images/whatfixpage.svg';
import ziplyneImage from './images/SideBySide - Zipylne.svg';
import competitorImage from './images/SideBySide-Whatfix.svg';
import useMediaQuery from "@material-ui/core/useMediaQuery";

function Ziplyne_whatfix() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif'
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const screenIsMobile = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <>
            <Helmet>
                <title>Ziplyne vs Whatfix</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <main>
                            <Parallax y={[-15, 15]}>
                                <PageHeaderSection screenIsSmall={screenIsSmall}>
                                    Get rid of the “WHAT??!!”.....Upgrade the Fix!
                                </PageHeaderSection>
                            </Parallax>
                            {screenIsMobile &&
                                <div className="combined-background">
                                    <MountainInfoSection
                                        content={"At Ziplyne we understand that the key to successful Digital Adoption is effective in-app guidance. That is why we’ve designed a product that seamlessly aligns our Zips/Guides to maximize your Product Adoption KPIs and shorten the path to your destination...And we know that your product will be constantly evolving so we’re built to grow, adapt and evolve with you."}
                                        media={mountainVideo}
                                        hideParallax={screenIsSmall}
                                    />
                                    <CombinedBarSection
                                        header={"We Listened...\nWe Built"}
                                        content={"Ziplyne understands that every company and business process is unique. It is why we designed a lightweight experience for you to create in-app guidance with ease and can be used by ANYONE to create content, regardless of their technical background."}
                                        image={graphic}
                                        videoHeader={"But don’t just take our word for it... Compare for yourself!"}
                                        hideParallax={screenIsSmall}
                                    />
                                </div>
                            }
                            {!screenIsMobile &&
                                <>
                                    <MountainInfoSection
                                        content={"At Ziplyne we understand that the key to successful Digital Adoption is effective in-app guidance. That is why we’ve designed a product that seamlessly aligns our Zips/Guides to maximize your Product Adoption KPIs and shorten the path to your destination...And we know that your product will be constantly evolving so we’re built to grow, adapt and evolve with you."}
                                        media={mountainVideo}
                                        hideParallax={screenIsSmall}
                                    />
                                    <CombinedBarSection
                                        header={"We Listened...\nWe Built"}
                                        content={"Ziplyne understands that every company and business process is unique. It is why we designed a lightweight experience for you to create in-app guidance with ease and can be used by ANYONE to create content, regardless of their technical background."}
                                        image={graphic}
                                        videoHeader={"But don’t just take our word for it... Compare for yourself!"}
                                        hideParallax={screenIsSmall}
                                    />
                                </>
                            }
                            <DiamondInfoSection
                                content={"And best of all, Ziplyne’s ease of use unlocks multiple new paths of value and productivity including lower TCO and greater scalability!"}
                                ziplyneImage={ziplyneImage}
                                competitorImage={competitorImage}
                            />
                        </main>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    )
        ;
}

export default Ziplyne_whatfix;
